import { useCallback, useMemo } from 'react';
import { emitAck } from '../adminEmit';

export function useAdminRequestsApi(socket) {
  const listRequests = useCallback(
    (params) => emitAck(socket, 'admin:requests:list', params),
    [socket]
  );
  const getRequest = useCallback(
    (taskId) => emitAck(socket, 'admin:requests:get', { taskId }),
    [socket]
  );

  return useMemo(() => ({ listRequests, getRequest }), [listRequests, getRequest]);
}
